import { SectionCard } from "./SectionCard";
import { fmtUSD, fmtDate, fmtCliente } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export default function PagaresPendientes({ data }) {
  if (!data) return null;
  return (
    <SectionCard
      id="pagares-pendientes"
      testid="section-pagares-pendientes"
      num="4"
      title="Detalle de Pagarés Pendientes de Firma"
      description="Agrupados por cliente y fecha de emisión. La alerta roja se activa cuando pasan más de 60 días desde la emisión sin firma."
      action={
        data.alertas_criticas > 0 && (
          <span
            data-testid="alertas-criticas-badge"
            className="px-3 py-1.5 text-xs font-bold bg-red-100 text-red-700 border border-red-200 rounded-full inline-flex items-center gap-1.5 animate-pulse"
          >
            <AlertTriangle className="h-3.5 w-3.5" />
            {data.alertas_criticas} con +60 días
          </span>
        )
      }
    >
      <div className="overflow-x-auto rounded-lg border border-slate-100">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wide">
              <th className="text-left px-4 py-3 font-semibold">Cliente</th>
              <th className="text-left px-4 py-3 font-semibold">Emisión</th>
              <th className="text-center px-4 py-3 font-semibold">Cant.</th>
              <th className="text-right px-4 py-3 font-semibold">Valor Total</th>
              <th className="text-center px-4 py-3 font-semibold">Días desde Emisión</th>
              <th className="text-center px-4 py-3 font-semibold">Estado</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((r, i) => (
              <tr key={i} className={`border-t border-slate-100 ${r.alerta ? "bg-red-50/60" : "hover:bg-emerald-50/40"}`}>
                <td className="px-4 py-2.5 font-medium text-slate-800"><span className="block truncate" title={r.cliente} style={{ maxWidth: "260px" }}>{fmtCliente(r.cliente)}</span></td>
                <td className="px-4 py-2.5 font-mono text-xs text-slate-600">{fmtDate(r.fecha_emision)}</td>
                <td className="px-4 py-2.5 text-center font-mono text-slate-700">{r.cantidad}</td>
                <td className="px-4 py-2.5 text-right font-mono font-semibold text-slate-900">{fmtUSD(r.valor_total_usd)}</td>
                <td className={`px-4 py-2.5 text-center font-mono font-semibold ${r.dias_transcurridos > 60 ? "text-red-600" : r.dias_transcurridos > 0 ? "text-amber-600" : "text-emerald-600"}`}>
                  {r.dias_transcurridos > 0 ? `${r.dias_transcurridos} d` : "Reciente"}
                </td>
                <td className="px-4 py-2.5 text-center">
                  {r.alerta ? (
                    <span className="px-2.5 py-1 text-[10px] font-bold bg-red-100 text-red-700 border border-red-200 rounded-full inline-flex items-center gap-1 animate-pulse">
                      <AlertTriangle className="h-3 w-3" /> +60 DÍAS
                    </span>
                  ) : r.dias_transcurridos > 0 ? (
                    <span className="px-2.5 py-1 text-[10px] font-medium bg-amber-100 text-amber-800 border border-amber-200 rounded-full">En proceso</span>
                  ) : (
                    <span className="px-2.5 py-1 text-[10px] font-medium bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-full">Reciente</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-emerald-50 border-t-2 border-emerald-200 font-semibold">
              <td className="px-4 py-3 text-emerald-900 uppercase text-xs tracking-wide" colSpan={3}>Total Pendiente de Firma</td>
              <td className="px-4 py-3 text-right font-mono text-emerald-900">{fmtUSD(data.total_valor_usd)}</td>
              <td colSpan={2}></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </SectionCard>
  );
}
